_collow.components.OverviewStepPage = class OverviewStepPage extends _collow.components.Base {
    root;
    elements;
    params;
    stepTitles;
    pencilIcons;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.stepTitlesContainer = document.querySelectorAll(".step-overview__text-container")
      this.pencilIcons = document.querySelectorAll(".step-overview__step-title .fa-pencil")

      this.listen(document, "_get-steps-info", this.getStespInfo)
      this.pencilIcons.forEach(pencil => pencil.addEventListener("click", (e) => this.goToItsStep(e)) )
    }

    getStespInfo = ({detail}) => {
      const {data} = detail
      data.length > 0 && this.addInfoToStep(data)
    }

    addInfoToStep = (data) => {
      const paragraphs = document.querySelectorAll(".step-overview__step-info")
      paragraphs && paragraphs.forEach(p => p.remove())
      const allStepsInfo = data.map(stepInfo => ({stepName: stepInfo.stepName, data: stepInfo.data, label: stepInfo?.label}))

      this.stepTitlesContainer.forEach(titleContainer => {
        const stepName = titleContainer.getAttribute("step-name")
        
        if(["Overview", "Overzicht"].includes(stepName)) {
          return
        }
        
        if(["Learning goals", "Leerdoelen"].includes(stepName)) {
          const learningGoalData = allStepsInfo.find(step => step.stepName === stepName).data
          learningGoalData.forEach((el, index) => {
            const p = document.createElement('p')

            p.classList.add("step-overview__step-info")
            p.textContent =`${index + 1} ${el}`
            
            titleContainer.appendChild(p)
          })
          return
        }
        
        const p = document.createElement('p')
        p.classList.add("step-overview__step-info")
        if (['Onderwerp', 'Subject', 'Context'].includes(stepName)) p.classList.add("notranslate")
        const stepInfo = allStepsInfo.find(step => step.stepName === stepName)
        p.textContent = stepInfo?.label || stepInfo.data

        titleContainer.appendChild(p)
      });
       
    }

    goToItsStep = (e) => {
      const setpNumberToGo = e.target.closest(".step-overview__text-container").getAttribute("step-number")
      this.dispatch(this.root, "_show-next-step", {step: Number(setpNumberToGo)});
      this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, edit: true});
      this.dispatch(this.root, "_replace-buttons", {action: "prev"});
    }
    
};
  
   
  
  
  
  
  
  